export default function ErrorBadge({error}) {
  return (
      <div className="flex justify-center items-center h-full"><p className="text-red-600">Error: {error}</p></div>
  )
}
